<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Notification from "@/services/Notification";
export default {
  components: { Layout, PageHeader },
  page: {
    title: "Notifications Topic",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      error: null,
      tableData: [],
      title: "Notification Topics",
      items: [
        { text: "Notifications" },
        { text: "Notification Topics", active: true },
      ],
      isBusy: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "device_id",
      sortDesc: false,
      isTopicsLoading: true, // loader for topics
      topics: [],
      selectedTopic: null,
      filterData: false,
      fields: [
        { key: "device_id", label: "Device Id", visible: true },
        { key: "name", label: "Name", visible: true },
        { key: "email", label: "Email" },
        { key: "device_os", label: "Device OS" },
        { key: "device_type", label: "Device Type", visible: true }
      ],
      // Topics table UI state
      topicFilter: null,
      topicSortBy: "count",
      topicSortDesc: true,
      topicPerPage: 10,
      topicCurrentPage: 1,
      topicPageOptions: [10, 25, 50, 100],
      topicTotalRows: 0,
      topicFilteredItems: [],
      topicFields: [
        { key: "topic", label: "Topic", sortable: true },
        { key: "count", label: "Subscribers", sortable: true },
        { key: "actions", label: "Actions" }
      ],
    };
  },

  async created() {
    await this.getTopics();
  },

  computed: {
    normalizedTopics() {
      return (this.topics || []).map(t => ({
        topic: t.topic,
        count: Number(((t && t['count(*)']) != null ? t['count(*)'] : ((t && t.count) != null ? t.count : 0)))
      }));
    },
  },

  methods: {
    async getTopics() {
      this.isTopicsLoading = true;

      try {
        const response = await Notification.getNotificationsTopic();
        const data = response && response.data ? (response.data.data != null ? response.data.data : response.data) : [];
        this.topics = data || [];
        this.topicTotalRows = this.topics.length;
        this.topicFilteredItems = this.normalizedTopics;
      } catch (error) {
        this.error = (error && error.response && error.response.data && error.response.data.error) ? error.response.data.error : "Failed to fetch topics.";
        this.topics = [];
        this.topicTotalRows = 0;
        this.topicFilteredItems = [];
      } finally {
        this.isTopicsLoading = false;

      }
    },

    async getTopicSubscriptions(topic) {
      this.isBusy = true;        // ✅ set busy BEFORE API call
      this.filterData = true;    // show table area immediately
      this.error = '' //reset error
      this.selectedTopic = topic;
      this.tableData = [];       // clear previous data

      try {
        const response = await Notification.getNotificationsTopicSubscriptions(topic);
        const data = response && response.data ? (response.data.data != null ? response.data.data : response.data) : [];
        this.tableData = data || [];
        this.totalRows = this.tableData.length;
      } catch (error) {
        this.error = (error && error.response && error.response.data && error.response.data.error) ? error.response.data.error : "Failed to fetch subscriptions.";
        this.tableData = [];
        this.totalRows = 0;
      } finally {
        this.isBusy = false;    // ✅ unset busy AFTER API call
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onTopicsFiltered(filteredItems) {
      this.topicTotalRows = filteredItems.length;
      this.topicCurrentPage = 1;
      this.topicFilteredItems = filteredItems;
    },

    // removed optional chaining to ensure compatibility with older babel setups
  },

  watch: {
    perPage() {
      this.currentPage = 1;
    },
    filter() {
      this.currentPage = 1;
    },
    topicPerPage() {
      this.topicCurrentPage = 1;
    },
    topicFilter() {
      this.topicCurrentPage = 1;
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Topics Controls -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select v-model="topicPerPage" size="sm" :options="topicPageOptions" />
                  &nbsp;topics
                </label>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="d-inline-flex align-items-center float-end">
                  Search topics:
                  <b-form-input
                      v-model="topicFilter"
                      type="search"
                      placeholder="Search topics..."
                      class="form-control form-control-sm ms-2"
                  />
                </label>
              </div>
            </div>

            <!-- Topics Stats -->
            <div class="row mt-3">
              <div class="col d-flex flex-wrap gap-3">
                <div class="me-3">
                  <span class="text-muted">Topics:</span>
                  <span class="fw-semibold">{{ (topicFilteredItems && topicFilteredItems.length) ? topicFilteredItems.length : normalizedTopics.length }}</span>
                </div>
              </div>
            </div>

            <!-- Topics Table -->
            <div class="table-responsive mb-3 mt-2">
              <b-table
                  :items="normalizedTopics"
                  :fields="topicFields"
                  :busy="isTopicsLoading"
                  :per-page="topicPerPage"
                  :current-page="topicCurrentPage"
                  :sort-by.sync="topicSortBy"
                  :sort-desc.sync="topicSortDesc"
                  :filter="topicFilter"
                  @filtered="onTopicsFiltered"
                  show-empty
                  empty-text="No Topics Found"
              >
                <template #cell(topic)="{ value }">
                  <div class="d-flex align-items-center">
                    <i class="bx bx-bell me-2 text-primary"></i>
                    <span class="fw-semibold">{{ value }}</span>
                  </div>
                </template>
<!--                <template #cell(count)="{ item }">-->
<!--                  <div class="text-end">-->
<!--                    <b-badge variant="secondary" class="px-2 py-1">{{ Number(item.count != null ? item.count : 0) }}</b-badge>-->
<!--                  </div>-->
<!--                </template>-->

                <template #cell(actions)="{ item }">
                  <b-button size="sm" variant="primary" @click="getTopicSubscriptions(item.topic)">
                    See Subscribers
                  </b-button>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle me-2"></b-spinner>
                    <strong>Loading topics...</strong>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Topics Pagination -->
            <div class="row">
              <div class="col">
                <div class="float-end">
                  <b-pagination
                      v-model="topicCurrentPage"
                      :total-rows="topicTotalRows"
                      :per-page="topicPerPage"
                      class="pagination pagination-rounded mb-0"
                  />
                </div>
              </div>
            </div>
            <!-- Stats -->

            <div class="row mt-4" v-if="!topicFilteredItems || topicFilteredItems.length === 0">
              <div class="col d-inline-flex align-items-center">
                <h4 class="card-title m-0">
                  Topic: {{ selectedTopic }} — Total Subscriptions: {{ totalRows }}
                </h4>
              </div>
            </div>
            <div v-else class="mt-4">
              <b-alert v-if="error" variant="danger" show class="mb-3">{{ error }}</b-alert>
            </div>
            <!-- Search & per-page -->
            <div class="row mt-4" v-if="filterData">
              <div class="col-sm-12 col-md-6">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions" />
                  &nbsp;entries
                </label>
              </div>
              <div class="col-sm-12 col-md-6">
                <label class="d-inline-flex align-items-center float-end">
                  Search:
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                  />
                </label>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0 font-size-12" v-if="filterData">
              <b-table
                  :items="tableData"
                  :fields="fields"
                  :busy="isBusy"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No Data Found"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ms-1">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Pagination -->
            <div class="row" v-if="filterData">
              <div class="col">
                <div class="float-end">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      class="pagination pagination-rounded mb-0"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
